import { render, staticRenderFns } from "./DailyMenu.vue?vue&type=template&id=6c4c853a"
import script from "./DailyMenu.vue?vue&type=script&lang=ts"
export * from "./DailyMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports